const OtherInvestments = {
  label: 'Your Investments',
  sections: [
    {
      type: 'text',
      text:
        '<h5>You are actually losing money if you just leave it in the bank</h5>',
    },
    {
      type: 'text',
      text: () => {
        return `
        <img class="full-width" src="https://assets1.cleartax-cdn.com/clearsave/images/bank_sucks_v7.png" />
        `;
      },
    },
  ],
};

export default OtherInvestments;



// WEBPACK FOOTER //
// ./components/recommendation/cards/otherInvestments.ts